export default {
	styleOverrides: {
		root: ({ theme }) => ({
			color: theme.palette.black,
			'&.Mui-focused': {
				color: theme.palette.black,
			},
			'&.MuiInputLabel-shrink': {
				color: theme.palette.black,
			},
		}),
	},
}
